module.exports = __webpack_public_path__ + "static/media/ico-comments-count.c10789da.svg";